function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _defineProperty(this, "operations", []);
  }

  var _proto = _default.prototype;

  _proto.execute = function execute() {
    var _this = this;

    this.operations.reduce(function (queuePromise, operation) {
      return queuePromise.then(function () {
        // console.log('Operation queue', {executing: operation});
        return operation().then(function () {
          var operationIndex = _this.operations.indexOf(operation);

          if (operationIndex > -1) {
            _this.operations.splice(operationIndex, 1);
          }
        });
      });
    }, Promise.resolve()).then(function () {
      if (_this.operations.length > 0) {
        return _this.execute();
      }
    });
  };

  _proto.add = function add(operation) {
    // console.log('Operation queue', { adding: operation });
    this.operations.push(operation);
  };

  return _default;
}();

export { _default as default };